import { CheckCircleIcon, CircleAlertIcon, CrossIcon } from '../../Icons';
import { alertVariants, closeButtonVariants, iconVariants } from '../logic';
import type { ActionProps, AlertType, TitleDescriptionProps } from '../types';
import styles from './styles.module.scss';

type BaseProps = {
  /** 閉じるボタンを表示するか */
  showClose?: boolean;
  /** 閉じるボタンをクリックした時のイベントハンドラー */
  onClickClose?: () => void;
  /** アラートの種類 */
  status: AlertType;
};

type Props = BaseProps & TitleDescriptionProps & ActionProps;

export const AlertPresentation: React.FC<Props> = ({
  title,
  description,
  action,
  actionLink,
  onAction,
  showClose = false,
  onClickClose,
  status = 'info',
  ...props
}) => {
  const wrapperClasses = alertVariants({ status });
  const buttonClasses = closeButtonVariants({ status });
  const iconClasses = iconVariants({ status });
  const isCompact = !title || !description;

  const getIcon = () => {
    switch (status) {
      case 'success':
        return <CheckCircleIcon size='md' />;
      case 'error':
        return <CircleAlertIcon size='md' />;
      case 'warning':
        return <CircleAlertIcon size='md' />;
      default:
        return <CircleAlertIcon size='md' />;
    }
  };

  return (
    <div className={`${wrapperClasses} ${isCompact ? styles.compact : ''}`} {...props}>
      {showClose && (
        <button className={buttonClasses} onClick={onClickClose} type='button'>
          <CrossIcon size='xs' />
        </button>
      )}
      <div className={styles.content}>
        <div className={iconClasses}>{getIcon()}</div>
        <div className={styles.textContainer}>
          {title && (
            <div className={`${styles.textWrapper} ${styles.titleWrapper}`}>
              <h2 className={styles.title}>{title}</h2>
            </div>
          )}
          {description && (
            <div className={`${styles.textWrapper} ${styles.descriptionWrapper}`}>
              <p className={styles.description}>{description}</p>
            </div>
          )}
          {action &&
            (onAction ? (
              <button className={styles.action} onClick={onAction} type='button'>
                {action}
              </button>
            ) : (
              <a
                className={styles.action}
                href={actionLink}
                target='_blank'
                rel='noopener noreferrer'
              >
                {action}
              </a>
            ))}
        </div>
      </div>
    </div>
  );
};
